module.exports = __webpack_public_path__ + "img/potential.4ef2bfdc.webp";